module.exports = __webpack_public_path__ + "static/de38a0a3.end.png";